import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import { environment } from '../../../env/environment';

@Injectable({
  providedIn: 'root'
})
export class ExtractsService {

//Ici la liste des base url des apis des extractions reporting
  APIBI_URI = environment.APIBI_URI;
  host_prod ='/api/prod';
  host_client ='/api/client';
  host_facturation ='/api/facturation';
  host_db='/api/DB';
  constructor( private http: HttpClient ) { }

  private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

//Api qui recuperer la  listes des nom des reporting prod
  list_views(){
    const url_prod = `${this.APIBI_URI + this.host_prod}/views`;
    return  this.http.get(url_prod, { headers: this.getAuthHeaders() });

  }

//Api qui recuperer la  listes des nom des DO
list_do(){
  const url_prod = `${ this.APIBI_URI +  this.host_prod}/DOs`;
  return  this.http.get(url_prod, { headers: this.getAuthHeaders() });

}


//Api qui recuperer la  listes des agents
  list_agents() {
    const url = `${this.APIBI_URI +  this.host_prod}/agents`;
    return this.http.get<string[]>(url, { headers: this.getAuthHeaders() });
  }

//Api qui recuperer la  listes des queues
  list_queues() {
    const url = `${this.APIBI_URI + this.host_prod}/queues`;
    return this.http.get<string[]>(url, { headers: this.getAuthHeaders() });
  }



  //Api qui exporter un rapport

  exportReport(
    table_name: string,
    filter_value: string,
    start_date: string,
    end_date: string,
    export_csv: boolean = false
  ): Observable<any> {
    const url = `${this.APIBI_URI + this.host_prod}/extract/${table_name}/${filter_value}`;

    let params = new HttpParams()
      .set('start_date', start_date)
      .set('end_date', end_date);

    if (export_csv) {
      params = params.set('export', 'csv');
    }

    const options = {
      headers: this.getAuthHeaders(),
      params: params,
      responseType: export_csv ? 'blob' as 'json' : 'json'
    };

    return this.http.get(url, options);
  }

  /**
   * Télécharge un fichier CSV
   */
  downloadFile(data: Blob, filename: string) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }




  //Api qui exporter un rapport
  previewReport(
    table_name: string,
    filter_value: string,
    start_date: string,
    end_date: string,
  ): Observable<any> {
    const url = `${this.APIBI_URI + this.host_prod}/preview/${table_name}/${filter_value}`;

    // Formatage des dates au format JJ/MM/AAAA si nécessaire
    const formattedStartDate = this.formatDate(start_date);
    const formattedEndDate = this.formatDate(end_date);

    let params = new HttpParams()
      .set('start_date', formattedStartDate)
      .set('end_date', formattedEndDate);

    const options = {
      headers: this.getAuthHeaders(),
      params: params,
    };

    return this.http.get(url, options).pipe(
      catchError(error => {
        console.error('Erreur lors de la prévisualisation:', error);
        return throwError(() => new Error('Erreur lors de la récupération des données'));
      })
    );
  }

  private formatDate(dateString: string): string {
    if (!dateString) return '';

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      return dateString;
    }

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString;
      }
      return `${this.padZero(date.getDate())}/${this.padZero(date.getMonth() + 1)}/${date.getFullYear()}`;
    } catch {
      return dateString;
    }
  }

  private padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }



  //Api qui recuperer la  listes des nom des DO par leur modele(a,b,c) d'export
  list_do_client(){
    const url_prod = `${this.APIBI_URI + this.host_client}/DOs`;
    return  this.http.get(url_prod, { headers: this.getAuthHeaders() });

  }



  //Api qui recuperer la  listes des nom des DO par leur modele(a,b,c) d'export
  list_all_do(){
    const url_prod = `${this.APIBI_URI + this.host_client}/all`;
    return  this.http.get(url_prod, { headers: this.getAuthHeaders() });

  }

  //Api qui exporter un rapport client

  get_data_by_modele(
    do_value: string,
    modele: string,
    start_date: string,
    end_date: string,
    export_csv: boolean = false
  ): Observable<any> {
    const url = `${this.APIBI_URI + this.host_client}/data`;

    let params = new HttpParams()
      .set('do', do_value)
      .set('modele', modele)
      .set('start_date', start_date)
      .set('end_date', end_date);

    if (export_csv) {
      params = params.set('export', 'csv');
    }

    const options = {
      headers: this.getAuthHeaders(),
      params: params,
      responseType: export_csv ? 'blob' as 'json' : 'json'
    };

    return this.http.get(url, options);
  }

// Api qui prévisualise un rapport client (top 10)
  preview_data_by_modele(
    do_value: string,
    modele: string,
    start_date: string,
    end_date: string
  ): Observable<any> {
    const url = `${this.APIBI_URI + this.host_client}/preview`;

    const params = new HttpParams()
      .set('do', do_value)
      .set('modele', modele)
      .set('start_date', start_date)
      .set('end_date', end_date);

    const options = {
      headers: this.getAuthHeaders(),
      params: params
    };

    return this.http.get(url, options);
  }


get_do_facturation(typeFactu: string) {
  const url_factu = `${this.APIBI_URI}${this.host_facturation}/DO/${encodeURIComponent(typeFactu)}`;
  const options = {
    headers: this.getAuthHeaders()
  };

  return this.http.get<string[]>(url_factu, options);
}



  get_data_by_TypeFactu(

    do_value: string,
    typeFactu: string,
    mois: number,
    export_csv: boolean = false

  ): Observable<any> {

    const url = `${this.APIBI_URI + this.host_facturation}/data`;

    let params = new HttpParams()

      .set('do', do_value)
      .set('typeFactu', typeFactu.replace(/%20/g, ' '))
      .set('mois', mois.toString());

    if (export_csv) {
      params = params.set('export', 'csv');
    }

    const options: {
      headers: HttpHeaders;
      params: HttpParams;
      responseType: 'json' | 'blob';
    } = {
      headers: this.getAuthHeaders(),
      params: params,
      responseType: export_csv ? 'blob' : 'json'
    };

    // @ts-ignore
    return this.http.get(url, options);
  }

  preview_data_by_TypeFactu(
    do_value: string,
    typeFactu: string,
    mois: number,
  ): Observable<any> {
    const url = `${this.APIBI_URI + this.host_facturation}/preview`;
    const params = new HttpParams()
      .set('do', do_value)
      .set('typeFactu', typeFactu.replace(/%20/g, ' '))
      .set('mois', mois.toString());

    const options: {
      headers: HttpHeaders;
      params: HttpParams;
      responseType: 'json';
    } = {
      headers: this.getAuthHeaders(),
      params: params,
      responseType: 'json'
    };

    return this.http.get(url, options);
  }



// Extract table data as CSV
  exportTableToCsv(tableName: string): Observable<Blob> {
    const url = `${this.APIBI_URI}${this.host_db}/extract/${tableName}`;
    const params = new HttpParams().set('export', 'csv');

    return this.http.get(url, {
      headers: this.getAuthHeaders(),
      params: params,
      responseType: 'blob'
    });
  }


  list_tables(): Observable<string[]> {
  return this.http.get<string[]>(`${this.APIBI_URI}${this.host_db}/table`, { headers: this.getAuthHeaders() });
}


  getTableData(
  tableName: string
  ): Observable<any> {
    const url = `${this.APIBI_URI}${this.host_db}/preview/${tableName}`;

    const options: {
      headers: HttpHeaders;
      responseType: 'json';
    } = {
      headers: this.getAuthHeaders(),
      responseType: 'json'
    };

    return this.http.get(url, options);
  }

  api_suivi_envois(){

  const url = `${this.APIBI_URI + this.host_db}/suivi`;
    return  this.http.get(url, { headers: this.getAuthHeaders() });

  }


  get_stat(){

  const url = `${this.APIBI_URI + this.host_db}/stat`;
    return  this.http.get(url, { headers: this.getAuthHeaders() });

  }

}

